/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { wrap } from "comlink";
import { useTranslation } from "react-i18next";
import DriverPaymentService from '../../../../services/driverPaymentService';
import { useCompany } from '../../../../provider/companyProvider';

const worker = new Worker(new URL("./pdfOneDriverPaymentWorker.js", import.meta.url));
const workerApi = wrap(worker);

const usePdfDriverPayment = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { business } = useCompany();

  const pdfPayment = async (id) => {
    if (!id) return;
    setIsLoading(true);

    try {
      // Fetch payment data
      const data = await DriverPaymentService.fetchOne(id);
      const driverPayment = JSON.parse(JSON.stringify(data)); // clone safely

      // Pass everything to the worker
      const blobUrl = await workerApi.renderPDF({
        driverPayment,
        business,
        language: i18n.language,
        t: {
          paymentDataReport: t('paymentDataReport'),
          id: t('id'),
          driverName: t('driverName'),
          priceAmount: t('priceAmount'),
          note: t('note'),
          branch: t('branch'),
          user: t('user'),
          createdAt: t('createdAt'),
          currentDate: t('currentDate'),
          number: t('number'),
          invoiceNumber: t('invoiceNumber'),
          receiverPhone: t('receiverPhoneTable'),
          address: t('address'),
          totalPrice: t('totalPrice'),
          driverPrice: t('driverPrice'),
          netPrice: t('netPrice'),
          totalItems: t('totalItems'),
          totalPostAmount: t('totalPostAmount'),
          totalDriverAmount: t('totalDriverAmount'),
          netPostAmount: t('netPostAmount'),
        },
      });

      // Open PDF
      window.open(blobUrl);
    } catch (error) {
      console.error("Error generating PDF in worker:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, pdfPayment };
};

export default usePdfDriverPayment;
